/**
 * translate · «сопоставь Playwright ↔ Selenium» (S16 · T05). Per ADR-016.
 * Две колонки строк; тап строки слева → тап её аналога справа (одинаковый
 * data-pair). Совпало — пара зелёным и заблокирована; промах — встряска + счёт.
 * Все пары собраны → data-fin. Детерминированно (пары в разметке) — taster.
 *
 * Контракт:
 *   <div class="translate" data-fin="мораль">
 *     <div class="tr-head"><span class="tr-ttl">…</span>
 *       <span class="tr-cnt">сопоставлено <b class="tr-done">0</b>/N · промахов <b class="tr-miss">0</b></span></div>
 *     <div class="tr-instr">…</div>
 *     <div class="tr-cols">
 *       <div class="tr-col"><div class="tr-colh">Playwright</div>
 *         <div class="tr-item" data-pair="1">page.goto("…")</div>…</div>
 *       <div class="tr-col"><div class="tr-colh">Selenium</div>
 *         <div class="tr-item" data-pair="1">driver.get("…")</div>…</div>
 *     </div>
 *     <div class="tr-verdict" aria-live="polite"></div>
 *   </div>
 *
 * No-JS: обе колонки читаются как сравнение. StrictMode-safe (guard + cleanup).
 */
export function initTranslate(root: HTMLElement): () => void {
  if (typeof document === 'undefined') return () => {};
  const cleanups: Array<() => void> = [];

  root.querySelectorAll<HTMLElement>('.translate').forEach((el) => {
    if (el.dataset.trInit === '1') return;
    el.dataset.trInit = '1';
    const original = el.innerHTML;

    const items = Array.from(el.querySelectorAll<HTMLElement>('.tr-item'));
    const doneEl = el.querySelector<HTMLElement>('.tr-done');
    const missEl = el.querySelector<HTMLElement>('.tr-miss');
    const verdict = el.querySelector<HTMLElement>('.tr-verdict');
    if (items.length < 2) return;

    el.classList.add('tr-ready');
    const totalPairs = Math.floor(items.length / 2);
    let done = 0;
    let misses = 0;
    let selected: HTMLElement | null = null;

    const onItem = (e: Event) => {
      const it = e.currentTarget as HTMLElement;
      if (it.classList.contains('tr-paired')) return;
      if (!selected) {
        selected = it;
        it.classList.add('tr-sel');
        return;
      }
      if (it === selected) {
        it.classList.remove('tr-sel');
        selected = null;
        return;
      }
      if (it.dataset.pair === selected.dataset.pair) {
        it.classList.add('tr-paired');
        selected.classList.add('tr-paired');
        it.classList.remove('tr-sel');
        selected.classList.remove('tr-sel');
        selected = null;
        done += 1;
        if (doneEl) doneEl.textContent = String(done);
        if (done >= totalPairs && verdict) {
          el.classList.add('tr-done-all');
          verdict.textContent = el.dataset.fin || 'Сопоставлено. Концепты те же — синтаксис другой.';
          verdict.className = 'tr-verdict tr-ok';
        }
      } else {
        it.classList.add('tr-shake');
        window.setTimeout(() => it.classList.remove('tr-shake'), 350);
        selected.classList.remove('tr-sel');
        selected = null;
        misses += 1;
        if (missEl) missEl.textContent = String(misses);
        if (verdict) {
          verdict.textContent = 'Не пара. Сравни, ЧТО делает строка: действие то же, синтаксис разный.';
          verdict.className = 'tr-verdict tr-err';
        }
      }
    };

    items.forEach((it) => {
      it.setAttribute('role', 'button');
      it.tabIndex = 0;
      it.addEventListener('click', onItem);
    });

    cleanups.push(() => {
      items.forEach((it) => it.removeEventListener('click', onItem));
      el.innerHTML = original;
      el.classList.remove('tr-ready', 'tr-done-all');
      delete el.dataset.trInit;
    });
  });

  return () => cleanups.forEach((fn) => fn());
}
